import { FC, useContext } from "react";

import { AuthContext } from "../../../../contexts/AuthContext";
import {
    getUserAdminNotes,
    saveAdminNotes,
} from "../../../../services/api/admin/note";
import { getUserNotes, saveNotes } from "../../../../services/api/note";
import Note from "./Note";

import styles from "./styles.module.scss";

type Props = {
    user: { id: string };
};

const Notes: FC<Props> = ({ user }) => {
    const { hasResource } = useContext(AuthContext)!;

    return (
        <div className={styles.notes}>
            {hasResource("user-notes-admin") && (
                <Note
                    title="Notes admin"
                    fetchNote={() => getUserAdminNotes(user.id)}
                    saveNote={(content) => saveAdminNotes(user.id, { content })}
                />
            )}
            {hasResource("user-notes") && (
                <Note
                    title="Notes"
                    fetchNote={() => getUserNotes(user.id)}
                    saveNote={(content) => saveNotes(user.id, { content })}
                />
            )}
        </div>
    );
};

export default Notes;
